export const LIST_STANDARD = 'LIST_STANDARD';
export const UPDATE_STANDARD = 'UPDATE_STANDARD';
